const binding = { modules: {}, dataActions: {} };

    (binding.modules['dlvry-override-theme-variables'] = {
        c: () => require('partner/modules/dlvry-override-theme-variables/dlvry-override-theme-variables.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dlvry-override-theme-variables',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dlvry-override-theme-variables'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };